import { createSlice } from '@reduxjs/toolkit'

export const clickNextFileSlice = createSlice({
    name: 'clickNextFile',
    initialState: {
        result: null,
    },
    reducers: {
        setClickNextFile: (state, action) => {
            state.result = action.payload;
        },
    },
})

export const { setClickNextFile } = clickNextFileSlice.actions;

export const getClickNextFile = (state) => state.clickNextFile.result;

export default clickNextFileSlice.reducer